// extracted by mini-css-extract-plugin
export default {"list":"klrO","item":"Mz8p"};